// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve" width="24" height="24">
        <line class="st0" x1="22.3" y1="22.3" x2="17.7" y2="17.7" stroke-linecap="round"/>
        <circle fill="none" class="st0" cx="12.3" cy="12.3" r="7.5"/>
    </svg>
`
};

export const IconSearch = () => <span dangerouslySetInnerHTML={icon} />;

export default IconSearch;
